import {React, useEffect, useState} from "react";
import {
    BUTTON,
    POLL_TYPE,
} from "../../utils/constants";
import classes from "./ReleaseActivityPage.module.css";
import {convertPercentage, questionHasCorrectness} from "../../utils/helpers";
import { useTranslation } from "react-i18next";

import { ReactComponent as GRADIENT_IMG } from "./images/total_participants_gradient_img.svg";
import ViewMetricCardResponsesDoughnutChart from "./ViewMetricCardResponsesDoughnutChart";


export default function ViewMetricCardResponses({
                                                    dataResponses,
                                                    pollData=[],
                                                    curQuestionNo,
}) {
    const { t } = useTranslation();
    const [emptyDoughnutChartData, ] = useState(() => {
        let data = [];
        data.push({name: "correct", value: 1, fill: "#E1E1E1"});
        data.push({name: "incorrect", value: 1, fill: "#E1E1E1"});
        data.push({name: "unanswered", value: 1, fill: "#E1E1E1"});
        return data;
    });

    const [doughnutChartData, setDoughnutChartData] = useState([]);

    // const location = useLocation();
    const {poll={}, questions=[]} = pollData;

    const question = questions.find(q => q.serialNo === curQuestionNo);

    const COLOR_SECTION = {CORRECT: "#0B7E0F", INCORRECT: "#B40030", UNGRADED: "#778AB5", UNANSWERED: "#D7D5D5"}
    const BADGE_COLOR_SECTION = {CORRECT: "#e7f3e7", INCORRECT: "#f9e6eb", UNGRADED: "#D3DDF2", UNANSWERED: "#ECECEC"}
    /* bg */



    const [cardCollapsed, setCardCollapsed] = useState(false); // !location?.state?.expandedAnalytics
    const [chartData, setChartData] = useState({});

    useEffect(() => {
        let chartDataCopy = {};
        if (!!dataResponses && dataResponses.length > 0 && dataResponses.length >= curQuestionNo) {
            chartDataCopy = dataResponses[curQuestionNo - 1];
        } else {
            chartDataCopy = {total: 0, correct: 0, incorrect: 0, unanswered: 0, ungraded: 0};
        }
        setChartData(chartDataCopy);


        let doughnutChartDataCopy = [];

        if (poll.pollType !== POLL_TYPE.ATTENDANCE && !questionHasCorrectness(question)) {
            if (!!(chartDataCopy.total - chartDataCopy.unanswered)) {
                doughnutChartDataCopy.push({name: "answered", value: chartDataCopy.total - chartDataCopy.unanswered, fill: COLOR_SECTION.CORRECT})
            }
        } else {
            if (chartDataCopy.correct) {
                doughnutChartDataCopy.push({name: "correct", value: chartDataCopy.correct, fill: COLOR_SECTION.CORRECT})
            }

            if (chartDataCopy.incorrect) {
                doughnutChartDataCopy.push({name: "incorrect", value: chartDataCopy.incorrect, fill: COLOR_SECTION.INCORRECT})
            }

            if (chartDataCopy.ungraded) {
                doughnutChartDataCopy.push({name: "ungraded", value: chartDataCopy.ungraded, fill: COLOR_SECTION.UNGRADED})
            }
        }


        if (chartDataCopy.unanswered) {
            doughnutChartDataCopy.push({name: "unanswered", value: chartDataCopy.unanswered, fill: COLOR_SECTION.UNANSWERED})
        }



        setDoughnutChartData(doughnutChartDataCopy);


    }, [dataResponses, pollData, curQuestionNo]);

    useEffect( () => {
        if (Object.entries(chartData).length === 0 || !chartData.total) {
            if(document.getElementById("incorrectBar") !== null) {
                document.getElementById("incorrectBar").style.width = "0";
            }

            if(document.getElementById("correctBar") !== null) {
                document.getElementById("correctBar").style.width = "0";
            }
            return;
        }


        if(document.getElementById("incorrectBar") !== null) {
            let width = chartData.incorrect * 100 / chartData.total;
            document.getElementById("incorrectBar").style.width = width + "%";
        }
        if(document.getElementById("correctBar") !== null) {
            let width = chartData.correct * 100 /chartData.total;
            document.getElementById("correctBar").style.width = width + "%";
        }
    }, [chartData, cardCollapsed]);

    return(
        <div
            className={classes.metricCard}
            style={{maxHeight: cardCollapsed ? 50 : 800}}
        >
            <h2 className={classes.metricCardHeader}>
                <div className={classes.metricCardHeaderTitle}>
                    {poll.pollType !== POLL_TYPE.ATTENDANCE ? t("poll.analyticsQuestion", {number: curQuestionNo}) : t("poll.analyticsLabel")}
                </div>
                <span
                    tabIndex={0}
                    role={BUTTON}
                    aria-expanded={cardCollapsed ? "false" : "true"}
                    aria-controls={"response-card-body"}
                    aria-label={cardCollapsed ? t("accessibility.expandMetricsCard") : t("accessibility.collapseMetricsCard")}
                    className={classes.metricCardControlBtn}
                    onClick={() => setCardCollapsed(!cardCollapsed)}
                >
                    {cardCollapsed ? t("common.viewAll") : t("poll.viewLess")}
                </span>
            </h2>

            <div id={"response-card-body"} className={classes.metricCardBody} style={{visibility: cardCollapsed ? "hidden" : "visible"}}>

                <div className={`${classes.metricCardTotalParticipantsContainer} ${classes.row}`}>
                    <GRADIENT_IMG style={{position: "absolute", top: 0, left: 0}}/>
                    <div
                        className={classes.row}
                        style={{position: "absolute", top: 0, left: 0, height: "100%", width: "100%"}}
                    >
                        <div style={{width: 21}}/>
                        <span className={classes.metricCardGradientTotalParticipantsPartA}>
                            {chartData.total}
                        </span>
                        <div style={{width: 15}}/>
                        <span className={classes.metricCardGradientTotalParticipantsPartB}>{t("report.participantMetricTitle")}</span>

                    </div>
                </div>

                <ViewMetricCardResponsesDoughnutChart size={140} countData={doughnutChartData} emptyCountData={emptyDoughnutChartData} title={t("poll.responsesHeader")} emptyTitle={"Responses"}/>

                <div className={classes.column} style={{gap: 5}}>
                    {poll.pollType !== POLL_TYPE.ATTENDANCE && !questionHasCorrectness(question) &&
                        <div className={classes.row}>
                            <span className={classes.metricCardLegend} style={{background: COLOR_SECTION.CORRECT}}/>
                            <span className={classes.metricCardLegendLabel}>
                                {t("gradebook.answeredLabel")}
                            </span>
                            <span style={{flex: 1}}/>
                            <span className={classes.metricCardLegendBadge} style={{background: BADGE_COLOR_SECTION.CORRECT}}>
                                {chartData.total - chartData.unanswered}
                            </span>
                        </div>
                    }

                    {(poll.pollType === POLL_TYPE.ATTENDANCE || questionHasCorrectness(question)) &&
                        <div className={classes.row}>
                            <span className={classes.metricCardLegend} style={{background: COLOR_SECTION.CORRECT}}/>
                            <span className={classes.metricCardLegendLabel}>
                                {poll.pollType !== POLL_TYPE.ATTENDANCE ? t("gradebook.statusCorrect") : t("gradebook.presentLabel")}
                            </span>
                            <span style={{flex: 1}}/>
                            <span className={classes.metricCardLegendBadge} style={{background: BADGE_COLOR_SECTION.CORRECT}}>
                                {chartData.correct}
                            </span>
                        </div>
                    }

                    {(poll.pollType === POLL_TYPE.ATTENDANCE || questionHasCorrectness(question)) &&
                        <div className={classes.row}>
                            <span className={classes.metricCardLegend} style={{background: COLOR_SECTION.INCORRECT}}/>
                            <span className={classes.metricCardLegendLabel}>
                                {poll.pollType !== POLL_TYPE.ATTENDANCE ? t("gradebook.statusIncorrect") : t("gradebook.absentLabel")}
                            </span>
                            <span style={{flex: 1}}/>
                            <span className={classes.metricCardLegendBadge} style={{background: BADGE_COLOR_SECTION.INCORRECT}}>
                                {chartData.incorrect}
                            </span>
                        </div>
                    }

                    {!!chartData.unanswered &&
                        <div className={classes.row}>
                            <span className={classes.metricCardLegend} style={{background: COLOR_SECTION.UNANSWERED}}/>
                            <span className={classes.metricCardLegendLabel}>{t("gradebook.statusUnanswered")}</span>
                            <span style={{flex: 1}}/>
                            <span className={classes.metricCardLegendBadge} style={{background: BADGE_COLOR_SECTION.UNANSWERED}}>
                                {chartData.unanswered}
                            </span>
                        </div>
                    }

                    {!!chartData.ungraded &&
                        <div className={classes.row}>
                            <span className={classes.metricCardLegend} style={{background: COLOR_SECTION.UNGRADED}}/>
                            <span className={classes.metricCardLegendLabel}>{t("poll.ungradedText")}</span>
                            <span style={{flex: 1}}/>
                            <span className={classes.metricCardLegendBadge}
                                  style={{background: BADGE_COLOR_SECTION.UNGRADED}}>
                                {chartData.ungraded}
                            </span>
                        </div>
                    }
                </div>


                {(poll.pollType === POLL_TYPE.ATTENDANCE || questionHasCorrectness(question)) &&
                    <>
                        <div className={classes.column}>
                            <span className={classes.metricCardDescription}>{t("gradebook.statusCorrect")}</span>
                            <div style={{height: 4}}/>

                            <div className={classes.row}>
                                <span
                                    className={classes.metricCardLabel}>{convertPercentage(chartData.correct, chartData.total)}</span>
                                <span style={{flex: 1}}/>
                                <span
                                    className={classes.metricCardCountText}
                                    style={{color: COLOR_SECTION.CORRECT}}
                                >{t("poll.correctRatio", {done: chartData.correct, total: chartData.total})}</span>
                            </div>

                            <div style={{height: 10}}/>

                            <div className={classes.metricCardCountBarContainer}>
                                <div className={classes.metricCardCountBar} id="correctBar"
                                     style={{background: COLOR_SECTION.CORRECT}}>.
                                </div>
                            </div>

                            <div style={{height: 15}}/>


                            <span className={classes.metricCardDescription}>{t("gradebook.statusIncorrect")}</span>
                            <div style={{height: 4}}/>
                            <div className={classes.row}>
                                <span
                                    className={classes.metricCardLabel}>{convertPercentage(chartData.incorrect, chartData.total)}</span>
                                <span style={{flex: 1}}/>
                                <span
                                    className={classes.metricCardCountText}
                                    style={{color: COLOR_SECTION.INCORRECT}}
                                >{t("poll.incorrectRatio", {done: chartData.incorrect, total: chartData.total})}</span>
                            </div>
                            <div style={{height: 10}}/>
                            <div className={classes.metricCardCountBarContainer}>
                                <div id="incorrectBar" className={classes.metricCardCountBar}
                                     style={{background: COLOR_SECTION.INCORRECT}}>.
                                </div>
                            </div>
                            <div style={{height: 10}}/>
                        </div>
                    </>
                }



            </div>
        </div>
    );
}
